module.exports = __webpack_public_path__ + "static/media/addFieldIcon.c224dda2.svg";